import{Model} from 'ords/dist/model/model';

export class PersonalGoalsTask extends Model{
}

export const PersonalGoalsTaskModelConfig = {
    name: 'personalGoalsTask',
    model: PersonalGoalsTask,
    relations: [
        {name: 'personalgoal', model_name: 'personalGoals', returns_many: false, type: 'hasOne'},
        {name: 'personal_goal_task_deadline', model_name: 'PersonalGoalTaskDeadline', type: 'hasOne'},
        {name: 'personal_goal_task_file', model_name: 'PersonalGoalTaskFile', type: 'hasOne'}
    ]
}
